define(function riqInitServiceToastrConfig() {
  return {
    restrictedAccess: {
      type: 'error',
      title: '',
      // eslint-disable-next-line quotes
      message: "You don't have access to that page.",
      options: {}
    }
  };
});
